// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"87e3e76f","455":"fe2c4dd4"}[chunkId] + ".chunk.js";
};